import React, { useEffect, useState } from 'react'
import {
    Card,
    Row,
    Col,
    Pagination,
    Empty,
    Avatar,
    Spin,
} from 'antd';
import {
    DoubleRightOutlined,
    CheckCircleOutlined,
    PhoneOutlined
} from '@ant-design/icons';
import './index.scss'
import { hall } from '../../../../service'
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";


export default function TableView({ queryParams }) {
    const navigate = useNavigate()
        , [dataSource, setDataSource] = useState([])
        , [total, setTotal] = useState(null)
        , [spinning, setSpinning] = useState(false)
        , [pagination, setPagination] = useState({
            current: 1,
            pageSize: 12,
        })
        , { serverUrl } = useSelector(state => state.siteInfo)
        , { id } = useSelector(state => state.basic)

    useEffect(() => {
        async function fetchData() {
            fetch()
        }
        fetchData()
    }, [queryParams, pagination])

    const fetch = async () => {
        setSpinning(true)
        const { data: { records, total } } = await hall.apiHall.getList({ ...queryParams, ...pagination, type: 1 })
        setTotal(total)
        setDataSource(records)
        setSpinning(false)
    }

    const onPaginationChange = (pages) => {
        setPagination(prevState => {
            const newState = { ...prevState, current: pages }
            return newState;
        });
    }

    const onCardClick = (id) => {
        navigate(`/serviceshall/details/${id}`)
    }

    return (
        <div className='hall-table'>
            <Spin size='large' spinning={spinning} >
                {
                    dataSource.length ? (<Row>
                        {
                            dataSource.map((item, i) => (
                                <Col key={i.toString()} span={8}>
                                    {/* <Card
                                        hoverable
                                        className='table-card'
                                        cover={
                                            <img
                                                src={serverUrl + item.coverImage}
                                                className='table-card-img'
                                                alt=""
                                            />}
                                        actions={[
                                            // <span style={{ color: '#E4393C' }}>{`${item.price} 元/${item.unit}`}</span>,
                                            // <span>{item.classify1Name + '-' + item.classify2Name}</span>,
                                            <span>{item.phone}</span>,
                                        ]}
                                        onClick={() => onCardClick(item.id)}
                                    >
                                        <Card.Meta
                                            title={`${item.title}`}
                                            // title={`${item.pzName} - ${item.serviceName}`}
                                            description={<div>
                                                <p className='table-card-desc' style={{ color: '#44afad', fontWeight: 'bold' }}>{item.detail}</p>
                                                <p className='table-card-desc'>服务区域：{`${item.province}${item.city}${item.town}${item.address || ''}`}</p>
                                                <p className='table-card-desc'>发布人：{item.createName}</p>
                                                <p className='table-card-desc'>{`${item.startDate} ~ ${item.endDate}`}</p>
                                            </div>}
                                        />
                                    </Card> */}

                                    <Card
                                        style={{
                                            width: 380,
                                            marginBottom: 16,
                                        }}
                                        bodyStyle={{
                                            height: 160,
                                        }}
                                        actions={[
                                            <span style={{ color: '#2CB861' }}><CheckCircleOutlined /> 已认证</span>,
                                            <span><PhoneOutlined /> {
                                                id ? (<>{item.phone}</>) : (<>{item.phone.slice(0, 3) + '****' + item.phone.slice(7, 11)}</>)
                                            }</span>,
                                        ]}
                                        onClick={() => onCardClick(item.id)}
                                    >
                                        <Card.Meta
                                            avatar={<Avatar
                                                src={serverUrl + item.imageUrl}
                                                style={{ width: '100px', height: '100px' }}
                                            />}
                                            title={item.name}
                                            description={<>

                                                <div>实物支付：{item.matterPay === 1 ? <span className='color-primary'>支持</span> : '不支持'}</div>
                                                <div>公司地址：{item.address}</div>
                                            </>}
                                        />
                                    </Card>
                                </Col>
                            ))
                        }
                    </Row>) : (<Empty />)
                }

            </Spin>

            <Pagination
                className='table-pagination'
                total={total}
                current={pagination.current}
                pageSize={pagination.pageSize}
                showTotal={(total) => `共 ${total} 条`}
                onChange={(value) => onPaginationChange(value)}
            />
        </div>
    )
}
